{
  "jsm-project-summary-onboarding.closeButton": "Fechar",
  "jsm-project-summary-onboarding.moreAboutFeature": "Mais sobre o resumo do espaço",
  "jsm-project-summary-onboarding.okButton": "Entendi"
}